/** RBAC 權限碼（與後端 catalog／GET /auth/me 字串一致；勿臆造未列碼）。 */
export const PERM = {
  // —— 系統 ——
  SYS_HOME_READ: 'sys.home.read',
  SYS_ACCOUNT_READ: 'sys.account.read',
  SYS_ACCOUNT_CREATE: 'sys.account.create',
  SYS_ACCOUNT_UPDATE: 'sys.account.update',
  SYS_ROLE_READ: 'sys.role.read',
  SYS_ROLE_CREATE: 'sys.role.create',
  SYS_ROLE_UPDATE: 'sys.role.update',

  // —— IMS：庫存／物料 ——
  INVENTORY_STOCK_READ: 'ims.inventory_stock.read',
  INVENTORY_STOCK_SPLIT: 'ims.inventory_stock.split',
  MTR_READ: 'ims.mtr.read',
  MTR_CREATE: 'ims.mtr.create',
  MTR_UPDATE: 'ims.mtr.update',
  MTR_ACTIVATE: 'ims.mtr.activate',
  INSPECTION_KIND_READ: 'ims.inspection_kind.read',
  INSPECTION_KIND_CREATE: 'ims.inspection_kind.create',
  INSPECTION_KIND_UPDATE: 'ims.inspection_kind.update',

  // —— 倉別／出庫類別（sys 前綴；儲位與倉別共用 warehouse 權限） ——
  WAREHOUSE_READ: 'sys.warehouse.read',
  WAREHOUSE_CREATE: 'sys.warehouse.create',
  WAREHOUSE_UPDATE: 'sys.warehouse.update',
  STOCK_ISSUE_CATEGORY_READ: 'sys.stock_issue_category.read',
  STOCK_ISSUE_CATEGORY_CREATE: 'sys.stock_issue_category.create',
  STOCK_ISSUE_CATEGORY_UPDATE: 'sys.stock_issue_category.update',

  // —— IMS：單據 ——
  STOCK_RECEIPT_READ: 'ims.stock_receipt.read',
  STOCK_RECEIPT_CREATE: 'ims.stock_receipt.create',
  STOCK_RECEIPT_UPDATE: 'ims.stock_receipt.update',
  STOCK_RECEIPT_REVIEW: 'ims.stock_receipt.review',
  STOCK_TRANSFER_READ: 'ims.stock_transfer.read',
  STOCK_TRANSFER_CREATE: 'ims.stock_transfer.create',
  STOCK_TRANSFER_UPDATE: 'ims.stock_transfer.update',
  STOCK_TRANSFER_REVIEW: 'ims.stock_transfer.review',
  STOCK_ISSUE_READ: 'ims.stock_issue.read',
  STOCK_ISSUE_CREATE: 'ims.stock_issue.create',
  STOCK_ISSUE_UPDATE: 'ims.stock_issue.update',
  STOCK_ISSUE_REVIEW: 'ims.stock_issue.review',
  STOCK_ADJUSTMENT_READ: 'ims.stock_adjustment.read',
  STOCK_ADJUSTMENT_CREATE: 'ims.stock_adjustment.create',
  STOCK_ADJUSTMENT_UPDATE: 'ims.stock_adjustment.update',
  STOCK_ADJUSTMENT_REVIEW: 'ims.stock_adjustment.review',
  STOCKTAKE_READ: 'ims.stocktake.read',
  STOCKTAKE_CREATE: 'ims.stocktake.create',
  STOCKTAKE_UPDATE: 'ims.stocktake.update',
  STOCK_RETURN_READ: 'ims.stock_return.read',
  STOCK_RETURN_CREATE: 'ims.stock_return.create',
  STOCK_RETURN_UPDATE: 'ims.stock_return.update',
  STOCK_RETURN_REVIEW: 'ims.stock_return.review',

  // —— MOM ——
  /** handoff 有列；部分角色僅發 create/update 等，Aside 用 BOM_READ_CODES */
  BOM_READ: 'mom.bom.read',
  BOM_CREATE: 'mom.bom.create',
  BOM_UPDATE: 'mom.bom.update',
  BOM_ACTIVATE: 'mom.bom.activate',
  BOM_DELETE: 'mom.bom.delete',
  WORK_ORDER_READ: 'mom.work_order.read',
  WORK_ORDER_CREATE: 'mom.work_order.create',
  WORK_ORDER_UPDATE: 'mom.work_order.update',
  WORK_ORDER_REVIEW: 'mom.work_order.review',
  WORK_ORDER_AMENDMENT_CREATE: 'mom.work_order_amendment.create',
  WORK_ORDER_AMENDMENT_UPDATE: 'mom.work_order_amendment.update',
  WORK_ORDER_AMENDMENT_REVIEW: 'mom.work_order_amendment.review',
  // 工單維修單：BE 一律強制 RBAC（不受 enforcement JSON bypass）
  WORK_ORDER_REPAIR_READ: 'mom.work_order_repair.read',
  WORK_ORDER_REPAIR_CREATE: 'mom.work_order_repair.create',
  WORK_ORDER_REPAIR_UPDATE: 'mom.work_order_repair.update',
  WORK_ORDER_REPAIR_CLOSE: 'mom.work_order_repair.close',
  WORK_ORDER_REPAIR_CORRECT: 'mom.work_order_repair.correct',
  /** catalog 未 seed；分析入口跟製令 read（見 ANALYSIS_READ_CODES） */
  ANALYSIS_ORDERS_READ: 'mom.analysis.orders.read',
  ANALYSIS_MATERIALS_READ: 'mom.analysis.materials.read',
  PROCESSING_FACTORY_READ: 'mom.processing_factory.read',
  PROCESSING_FACTORY_CREATE: 'mom.processing_factory.create',
  PROCESSING_FACTORY_UPDATE: 'mom.processing_factory.update',

  // —— CRM ——
  CUSTOMER_READ: 'crm.customer.read',
  CUSTOMER_CREATE: 'crm.customer.create',
  CUSTOMER_UPDATE: 'crm.customer.update',
  CUSTOMER_ACTIVATE: 'crm.customer.activate',
  PRODUCT_READ: 'crm.product.read',
  PRODUCT_CREATE: 'crm.product.create',
  PRODUCT_UPDATE: 'crm.product.update',
  PRODUCT_ACTIVATE: 'crm.product.activate',
  CUSTOMER_ORDER_READ: 'crm.customer_order.read',
  CUSTOMER_ORDER_CREATE: 'crm.customer_order.create',
  CUSTOMER_ORDER_UPDATE: 'crm.customer_order.update',
  CUSTOMER_ORDER_REVIEW: 'crm.customer_order.review',
  CUSTOMER_COLLECTION_SUMMARY_READ: 'crm.customer_collection_summary.read',
  QUOTATION_READ: 'crm.quotation.read',
  QUOTATION_CREATE: 'crm.quotation.create',
  QUOTATION_UPDATE: 'crm.quotation.update',
  COST_ESTIMATE_READ: 'crm.cost_estimate.read',
  COST_ESTIMATE_CREATE: 'crm.cost_estimate.create',
  COST_ESTIMATE_UPDATE: 'crm.cost_estimate.update',
  // —— FMS：客訂收款（應收）——
  FMS_CUSTOMER_COLLECTION_READ: 'fms.customer_collection.read',
  FMS_CUSTOMER_COLLECTION_UPDATE: 'fms.customer_collection.update',
  FMS_CUSTOMER_COLLECTION_CONFIRM: 'fms.customer_collection.confirm',
  SALES_ORDER_READ: 'crm.sales_order.read',
  SALES_ORDER_CREATE: 'crm.sales_order.create',
  SALES_ORDER_UPDATE: 'crm.sales_order.update',
  SALES_ORDER_REVIEW: 'crm.sales_order.review',

  // —— SRM ——
  SUPPLIER_READ: 'srm.supplier.read',
  SUPPLIER_CREATE: 'srm.supplier.create',
  SUPPLIER_UPDATE: 'srm.supplier.update',
  PURCHASE_ORDER_READ: 'srm.purchase_order.read',
  PURCHASE_ORDER_CREATE: 'srm.purchase_order.create',
  PURCHASE_ORDER_UPDATE: 'srm.purchase_order.update',
  PURCHASE_ORDER_REVIEW: 'srm.purchase_order.review',
  MISC_PURCHASE_ORDER_READ: 'srm.misc_purchase_order.read',
  MISC_PURCHASE_ORDER_CREATE: 'srm.misc_purchase_order.create',
  MISC_PURCHASE_ORDER_UPDATE: 'srm.misc_purchase_order.update',
  MISC_PURCHASE_ORDER_REVIEW: 'srm.misc_purchase_order.review',

  // —— Aftersales（產品維修） ——
  REPAIR_REQUEST_READ: 'aftersales.repair_request.read',
  REPAIR_REQUEST_CREATE: 'aftersales.repair_request.create',
  REPAIR_REQUEST_UPDATE: 'aftersales.repair_request.update',
  REPAIR_REQUEST_COMPLETE: 'aftersales.repair_request.complete',
  REPAIR_ITEM_READ: 'aftersales.repair_item.read',
  REPAIR_ITEM_UPDATE: 'aftersales.repair_item.update',
  REPAIR_REPORT_READ: 'aftersales.repair_report.read',
  REPAIR_REPORT_CREATE: 'aftersales.repair_report.create',
  REPAIR_REPORT_UPDATE: 'aftersales.repair_report.update',
  REPAIR_REPORT_DISCARD: 'aftersales.repair_report.discard',
  SIGN_RECEIPT_READ: 'aftersales.sign_receipt.read',
  SIGN_RECEIPT_CREATE: 'aftersales.sign_receipt.create',
  SIGN_RECEIPT_UPDATE: 'aftersales.sign_receipt.update',
  SIGN_RECEIPT_COMPLETE: 'aftersales.sign_receipt.complete',
  SN_PRODUCT_MAPPING_READ: 'aftersales.sn_product_mapping.read',
  SN_PRODUCT_MAPPING_CREATE: 'aftersales.sn_product_mapping.create',
  SN_PRODUCT_MAPPING_UPDATE: 'aftersales.sn_product_mapping.update',
  SN_PRODUCT_MAPPING_DELETE: 'aftersales.sn_product_mapping.delete',

  // —— FMS：請款單／憑證 ——
  FMS_PAYMENT_REQUEST_READ: 'fms.payment_request.read',
  FMS_PAYMENT_REQUEST_SELF: 'fms.payment_request.self',
  FMS_PAYMENT_REQUEST_CREATE: 'fms.payment_request.create',
  FMS_PAYMENT_REQUEST_UPDATE: 'fms.payment_request.update',
  FMS_PAYMENT_REQUEST_DELETE: 'fms.payment_request.delete',
  FMS_PAYMENT_REQUEST_SUBMIT: 'fms.payment_request.submit',
  FMS_PAYMENT_REQUEST_PROCESS: 'fms.payment_request.process',
  FMS_PAYMENT_REQUEST_REVIEW: 'fms.payment_request.review',
  FMS_PAYMENT_REQUEST_PAY: 'fms.payment_request.pay',
  FMS_PAYMENT_REQUEST_RECEIVE: 'fms.payment_request.receive',
  FMS_PAYMENT_REQUEST_CLOSE: 'fms.payment_request.close',
  FMS_PAYMENT_REQUEST_CANCEL: 'fms.payment_request.cancel',
  FMS_VOUCHER_READ: 'fms.voucher.read',
  FMS_VOUCHER_SELF: 'fms.voucher.self',
  FMS_VOUCHER_CREATE: 'fms.voucher.create',
  FMS_VOUCHER_UPDATE: 'fms.voucher.update',
  FMS_VOUCHER_DELETE: 'fms.voucher.delete',
  FMS_VOUCHER_SUBMIT: 'fms.voucher.submit',
  FMS_VOUCHER_CANCEL: 'fms.voucher.cancel',
  // —— FMS：採購付款（應付）——
  FMS_PURCHASE_PAYMENT_READ: 'fms.purchase_payment.read',
  FMS_PURCHASE_PAYMENT_UPDATE: 'fms.purchase_payment.update',
  FMS_PURCHASE_PAYMENT_CONFIRM: 'fms.purchase_payment.confirm',
  FMS_PURCHASE_PAYMENT_VOID: 'fms.purchase_payment.void',
  FMS_PURCHASE_PAYMENT_REFUND: 'fms.purchase_payment.refund',
};

/**
 * Aside `permissionAny` 群組：空陣列＝不過濾（維持可見）；
 * 非空時字串須與 /auth/me 的 permissions[] 完全一致。
 */

/** 主控台 Aside；me 未含 sys.home.read 時維持不過濾 */
export const HOME_READ_CODES = [];

export const INVENTORY_STOCK_READ_CODES = [PERM.INVENTORY_STOCK_READ];

/** 物料管理 Aside／hub：mtr read 涵蓋規格、模板、結構、製造商；檢測種類另計 */
export const MATERIAL_MGMT_READ_CODES = [
  PERM.MTR_READ,
  PERM.INSPECTION_KIND_READ,
];

/** 單據 hub：任一單據或出庫類別 read 即可見 */
export const DOCUMENT_MGMT_READ_CODES = [
  PERM.STOCK_RECEIPT_READ,
  PERM.STOCK_TRANSFER_READ,
  PERM.STOCK_ISSUE_READ,
  PERM.STOCK_ADJUSTMENT_READ,
  PERM.STOCKTAKE_READ,
  PERM.STOCK_ISSUE_CATEGORY_READ,
];

export const STORE_PLACE_READ_CODES = [PERM.WAREHOUSE_READ];

/** BOM：kai 等角色無 mom.bom.read，有 create/update/activate/delete 仍應可進列表 */
export const BOM_READ_CODES = [
  PERM.BOM_READ,
  PERM.BOM_CREATE,
  PERM.BOM_UPDATE,
  PERM.BOM_ACTIVATE,
  PERM.BOM_DELETE,
];

export const WORK_ORDER_READ_CODES = [PERM.WORK_ORDER_READ];

/** 有製令 read 即可用分析；日後 BE 補 analysis.* 仍相容 */
export const ANALYSIS_READ_CODES = [
  PERM.WORK_ORDER_READ,
  PERM.ANALYSIS_ORDERS_READ,
  PERM.ANALYSIS_MATERIALS_READ,
];

export const PROCESSING_FACTORY_READ_CODES = [PERM.PROCESSING_FACTORY_READ];

export const CUSTOMER_ORDER_READ_CODES = [PERM.CUSTOMER_ORDER_READ];

export const SALES_ORDER_READ_CODES = [PERM.SALES_ORDER_READ];

export const QUOTATION_READ_CODES = [PERM.QUOTATION_READ];

export const COST_ESTIMATE_READ_CODES = [PERM.COST_ESTIMATE_READ];

export const PRODUCT_READ_CODES = [PERM.PRODUCT_READ];

export const CUSTOMER_READ_CODES = [PERM.CUSTOMER_READ];


export const AFTERSALES_REPAIR_REQUEST_READ_CODES = [PERM.REPAIR_REQUEST_READ];

export const AFTERSALES_REPAIR_ITEM_READ_CODES = [PERM.REPAIR_ITEM_READ];

export const AFTERSALES_REPAIR_REPORT_READ_CODES = [PERM.REPAIR_REPORT_READ];

export const AFTERSALES_SIGN_RECEIPT_READ_CODES = [PERM.SIGN_RECEIPT_READ];

export const AFTERSALES_SN_PRODUCT_MAPPING_READ_CODES = [
  PERM.SN_PRODUCT_MAPPING_READ,
];

/** 產品維修 hub：任一售後 read 即可見 */
export const PRODUCT_REPAIR_HUB_READ_CODES = [
  ...AFTERSALES_REPAIR_REQUEST_READ_CODES,
  ...AFTERSALES_REPAIR_ITEM_READ_CODES,
  ...AFTERSALES_REPAIR_REPORT_READ_CODES,
  ...AFTERSALES_SIGN_RECEIPT_READ_CODES,
  ...AFTERSALES_SN_PRODUCT_MAPPING_READ_CODES,
];

export const PURCHASE_ORDER_READ_CODES = [PERM.PURCHASE_ORDER_READ];

export const MISC_PURCHASE_ORDER_READ_CODES = [PERM.MISC_PURCHASE_ORDER_READ];

export const SUPPLIER_READ_CODES = [PERM.SUPPLIER_READ];

/** 財務管理 Aside：會計審核用列表（請款單／憑證） */
export const FMS_PAYMENT_REQUEST_READ_CODES = [PERM.FMS_PAYMENT_REQUEST_READ];

export const FMS_VOUCHER_READ_CODES = [PERM.FMS_VOUCHER_READ];

/** 個人中心：填單人自己的請款單／憑證（`/self` 路由） */
export const FMS_PAYMENT_REQUEST_SELF_CODES = [PERM.FMS_PAYMENT_REQUEST_SELF];

export const FMS_VOUCHER_SELF_CODES = [PERM.FMS_VOUCHER_SELF];
